<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Course Module Form</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Module Name</mat-label>
      <input
        matInput
        placeholder="Module Name"
        [(ngModel)]="module.name"
        name="name"
        type="text"
        #name
        required />
      <mat-error *ngIf="!name.valid">Please enter a module name.</mat-error>
    </mat-form-field>

    <editor
      placeholder="Module Introduction"
      [(ngModel)]="module.description"
      name="description"
      [apiKey]="utils.getTinyMceAPIKey()"
      [init]="{
        base_url: '/assets/tinymce',
        plugins: 'link image lists table media charmap',
        menu: {
          format: {
            title: 'Format',
            items: 'bold italic underline strikethrough superscript subscript codeformat | blocks align | forecolor backcolor | removeformat'
          }
        },
        toolbar: 'undo redo | bold italic underline | forecolor backcolor | bullist numlist | link image media | table | hr | removeformat',
        license_key: 'gpl',
        height: 450
      }">
    </editor>
    <mat-error *ngIf="!module.description">Please enter a module description.</mat-error>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">
    <button
      type="submit"
      mat-raised-button
      class="my-2 ml-1 mr-2"
      [disabled]="!f.valid || inProgress || !module.description"
      color="primary">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      type="button"
      color="warn"
      mat-icon-button
      [disabled]="!module.id"
      class="dialog-remove-button m-1 ml-auto"
      (click)="onRemove()">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-dialog-actions>
</form>
